import { render, staticRenderFns } from "./AllAttributeForms.vue?vue&type=template&id=2dd3be42&scoped=true&"
import script from "./AllAttributeForms.vue?vue&type=script&lang=js&"
export * from "./AllAttributeForms.vue?vue&type=script&lang=js&"
import style0 from "./AllAttributeForms.vue?vue&type=style&index=0&id=2dd3be42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3be42",
  null
  
)

export default component.exports